import React from 'react';
import QueuesDropdownMenu from './Menus/QueuesDropdownMenu';
import useAppContext from 'flow/hooks/useAppContext';

const SupervisorAgentsHeader = () => {
    const { i18next } = useAppContext();
    return (
        <div className="inset-x-0 m-auto box-border flex h-full max-w-2xl grow flex-wrap items-center justify-between gap-2 py-0 ps-3 pe-1 text-gray-800">
            <h2 className="text-xl font-bold">
                {i18next.t('Supervisor.Overview.Users.Label')}
            </h2>
            <div className="flex text-sm">
                <QueuesDropdownMenu />
            </div>
        </div>
    );
};

export default SupervisorAgentsHeader;
